import { MpMakerTypeTotalCvObj } from '@modules/NewMaker/Type/S/Constant';

export const MpMakerMconUtil = {
  getMconThemeId: (cv_obj: MpMakerTypeTotalCvObj): number | undefined => {
    if (!cv_obj?._data) return;
    if ('mcon_theme_id' in cv_obj?._data) return cv_obj._data.mcon_theme_id;
    if ('cv_image_attrs' in cv_obj?._data) return cv_obj._data.cv_image_attrs._data?.mcon_theme_id;
  },
  getImageId: (cv_obj: MpMakerTypeTotalCvObj): number | undefined => {
    if (!cv_obj?._data) return;
    if ('image_id' in cv_obj?._data) return cv_obj._data.image_id;
    if ('cv_image_attrs' in cv_obj?._data) return cv_obj._data.cv_image_attrs._data?.image_id;
  },
};
